export const UNAUTH_CHANGE_PASSWORD_API_REQUEST = 'UNAUTH_CHANGE_PASSWORD_API_REQUEST';
export const UNAUTH_CHANGE_PASSWORD_API_ERROR = 'UNAUTH_CHANGE_PASSWORD_API_ERROR';
export const UNAUTH_CHANGE_PASSWORD_API_SUCCESS = 'UNAUTH_CHANGE_PASSWORD_API_SUCCESS';
export const RESET_UNAUTH_CHANGE_PASSWORD_SUCCESS =
  'UNAUTH_RESET_CHANGE_PASSWORD_SUCCESS';
